import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { Hero } from "../components/hero"
// import { VideosGrid } from "../components/videosGrid"
import { graphql } from "gatsby"
import { getImage, StaticImage } from "gatsby-plugin-image"

const NewVideosPage = ({ data }) => {
  // data prop is passed in automatically from the 'query' var on line 23 - this only works on 'pages' though
  const heroImage = getImage(data.heroImage)

  const vidStyle = {
    flexBasis: '100%',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 4
  }

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    gap: '2rem',
    // flexDirection: 'column',
    flexWrap: 1
  }
  return (
    <Layout page="new-videos">
      <Seo title="New Videos" />
      <Hero image={heroImage} title="New Videos" />
      <div style={containerStyle} className="container">
        
        <a style={vidStyle}  className='began-to-cry' href="https://youtu.be/nza4jZgEsdY" target="_blank" rel="noreferrer">
          <StaticImage
            src="../images/begantocry.jpeg"
            loading="eager"
            width={770}
            alt="Began To Cry Video"
          />
        </a>
        <a style={vidStyle}  className='began-to-cry' href="https://youtu.be/7Vk2DEeDOVA" target="_blank" rel="noreferrer">
          <StaticImage
            src="../images/blessence.jpeg"
            loading="eager"
            width={770}
            alt="Blessence Video"
          />
        </a>
        <a style={vidStyle} className='friedleggings' href="https://youtu.be/56jAPM79-i0" target="_blank" rel="noreferrer">
          <StaticImage
            src="../images/friedleggings.jpeg"
            loading="eager"
            width={770}
            alt="Friedleggings Video"
          />
        </a>
      </div>

    </Layout>
  )
}

// Get hero image and all thumbnail images for all videos
export const query = graphql`
  query {
    heroImage: imageSharp(resize: { originalName: { eq: "lumber-home.jpg" } }) {
      gatsbyImageData(width: 2791)
    }

  }
`

export default NewVideosPage
